import { render } from "./login.vue?vue&type=template&id=560d486c&scoped=true&ts=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=560d486c&lang=less&scoped=true"
import "@/style/common.less?vue&type=style&index=1&id=560d486c&scoped=true&lang=less&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560d486c"]])

export default __exports__